<template>
    <section id="service" class="section service-area dark-bg ptb_150">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-7">
                    <!-- Section Heading -->
                    <div class="section-heading text-center">
                        <h2 class="text-white">Nudimo Prvoklasnu Profesionalnu Uslugu</h2>
                        <p class="text-white-50 d-none d-sm-block mt-4">Pružamo visokokvalitetne usluge sa timom iskusnih procenitelja uz razumne cene i brzu isporuku.</p>
                        <p class="text-white-50 d-block d-sm-none mt-4">Pružamo visokokvalitetne usluge sa timom iskusnih procenitelja uz razumne cene i brzu isporuku.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-4">
                    <!-- Single Service -->
                    <div class="single-service media p-3">
                        <span class="icon color-1 icon-bg-1">01</span>
                        <!-- Service Text -->
                        <div class="media-body ml-4">
                            <h3 class="text-white">Procene Vrednosti Nepokretnosti</h3>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <!-- Single Service -->
                    <div class="single-service media p-3">
                        <span class="icon color-1 icon-bg-1">02</span>
                        <!-- Service Text -->
                        <div class="media-body ml-4">
                            <h3 class="text-white">Procene Vrednosti Pokretne Imovine</h3>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <!-- Single Service -->
                    <div class="single-service media p-3">
                        <span class="icon color-1 icon-bg-1">03</span>
                        <!-- Service Text -->
                        <div class="media-body ml-4">
                            <h3 class="text-white">Studije Izvodljivosti</h3>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <!-- Single Service -->
                    <div class="single-service media p-3">
                        <span class="icon color-1 icon-bg-1">04</span>
                        <!-- Service Text -->
                        <div class="media-body ml-4">
                            <h3 class="text-white">Projektno Finansiranje - Monitoring i Supervizija</h3>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <!-- Single Service -->
                    <div class="single-service media p-3">
                        <span class="icon color-1 icon-bg-1">05</span>
                        <!-- Service Text -->
                        <div class="media-body ml-4">
                            <h3 class="text-white">Statistički Modeli Procene Portfolija</h3>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <!-- Single Service -->
                    <div class="single-service media p-3">
                        <span class="icon color-1 icon-bg-1">06</span>
                        <!-- Service Text -->
                        <div class="media-body ml-4">
                            <h3 class="text-white">Analize Najbolje i Najisplativije Upotrebe</h3>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <!-- Single Service -->
                    <div class="single-service media p-3">
                        <span class="icon color-1 icon-bg-1">07</span>
                        <!-- Service Text -->
                        <div class="media-body ml-4">
                            <h3 class="text-white">Investiciono Savetovanje</h3>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <!-- Single Service -->
                    <div class="single-service media p-3">
                        <span class="icon color-1 icon-bg-1">08</span>
                        <!-- Service Text -->
                        <div class="media-body ml-4">
                            <h3 class="text-white">Energetska Efikasnost</h3>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <!-- Single Service -->
                    <div class="single-service media p-3">
                        <span class="icon color-1 icon-bg-1">09</span>
                        <!-- Service Text -->
                        <div class="media-body ml-4">
                            <h3 class="text-white">Analize Portfolija Imovine</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>
.icon {
    font-size: 42px;
    font-weight: 600;
}
.col-12 {
  margin-bottom: 20px;
}
</style>
